import { Box, Button, Typography } from '@mui/material'
import { FC, useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import colors from '../../constants/colors'
import ProgressBar from '../ProgressBar'
import { IUploadDropzone, uploadInputZones } from './types'

import CloseIcon from '@mui/icons-material/Close'
import constants from './constants'

const UploadDropzone: FC<IUploadDropzone> = ({
  onChange,
  iconAndText,
  acceptType = uploadInputZones.ALL,
  mainColor = colors.TAG_PURPLE,
}) => {
  const [fileSize, setFileSize] = useState(undefined)
  const [newFile, setNewFile] = useState(undefined)
  const [progress, setProgress] = useState(0)

  const onDrop = useCallback((acceptedFiles: any) => {
    // Do something with the files
    setNewFile(acceptedFiles[0])
    setFileSize(acceptedFiles[0].size)
  }, [])

  useEffect(() => {
    if (progress === 100) {
      onChange([newFile])
      setFileSize(undefined)
      setProgress(0)
    }
  }, [progress])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { ...constants.acceptanceTypes[acceptType] },
  })

  const cancelUpload = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    setNewFile(undefined)
    setFileSize(undefined)
    setProgress(0)
  }
  return (
    <Box
      sx={[constants.mainContainerStyle, { border: `2px dashed ${mainColor}`, cursor: 'pointer' }]}
    >
      <Box sx={[constants.dropZoneStyle]} {...getRootProps()}>
        {!fileSize && (
          <>
            <input {...getInputProps()} />
            {isDragActive ? (
              <Box sx={{ py: '2.5rem' }}>
                <Typography variant='bodyBold' sx={{ color: mainColor }}>
                  Drop the Files here ...
                </Typography>
              </Box>
            ) : iconAndText ? (
              <>
                {iconAndText}
                <Typography variant='textMedium' sx={{ color: mainColor }}>
                  Or drag and drop it here
                </Typography>
              </>
            ) : (
              <>
                <Typography variant='bodyBold' sx={{ color: mainColor }}>
                  Select a Video File to Upload
                </Typography>
                <Typography variant='textMedium' sx={{ color: mainColor }}>
                  Or drag and drop it here
                </Typography>
              </>
            )}
          </>
        )}
        {fileSize && (
          <Box sx={{ width: '100%' }}>
            <ProgressBar
              size={fileSize}
              externalProgress={progress}
              setExternalProgress={setProgress}
              themeColor={mainColor}
            />
          </Box>
        )}
      </Box>

      {fileSize && (
        <Button
          variant='outlined'
          sx={{ color: colors.BLACK, marginBottom: '2rem' }}
          startIcon={<CloseIcon />}
          onClick={cancelUpload}
        >
          <Typography variant='bodyRegular' color='inherit'>
            Cancel
          </Typography>
        </Button>
      )}
    </Box>
  )
}

export default UploadDropzone
